<app-status-pill [statusPill]="pill" />
